import { z } from 'zod';
export const MAX_FILE_SIZE = 100 * 1024 * 1024;
export const MAX_FILES_PER_MESSAGE = 10;
export const THUMB_MAX_EDGE = 640;
/**
 * Vegrehajthato kiterjesztesek.
 *
 * Nem a MIME tipust nezzuk: azt a kliens allitja, es konnyen hazudik. A NEV
 * vegzodese az, amit a Windows a letoltes utan dupla kattintasra ertelmez -
 * ezert azt szurjuk.
 */
export const BLOCKED_EXTENSIONS = [
    'exe',
    'scr',
    'bat',
    'cmd',
    'com',
    'pif',
    'msi',
    'msp',
    'vbs',
    'vbe',
    'js',
    'jse',
    'wsf',
    'wsh',
    'ps1',
    'psm1',
    'jár',
    'hta',
    'cpl',
    'dll',
    'lnk',
    'reg',
    'scf',
    'inf',
];
export const extensionOf = (name) => {
    const index = name.lastIndexOf('.');
    return index === -1 ? '' : name.slice(index + 1).toLowerCase();
};
export const isBlockedFileName = (name) => BLOCKED_EXTENSIONS.includes(extensionOf(name));
export const IMAGE_MIMES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/avif'];
export const isImageMime = (mime) => IMAGE_MIMES.includes(mime);
export const isVideoMime = (mime) => mime.startsWith('video/');
export const isAudioMime = (mime) => mime.startsWith('audio/');
export const isPdfMime = (mime) => mime === 'application/pdf';
// ─── Szerzodes ────────────────────────────────────────────────────────────────
export const fileAttachmentSchema = z.object({
    id: z.string(),
    name: z.string(),
    mime: z.string(),
    size: z.number(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    /**
     * ALLANDO utvonalak, nem lejaro alairt linkek: minden keresnel ujra
     * ellenorizzuk a jogosultsagot, es csak utana iranyitunk at a tarolora.
     */
    url: z.string(),
    thumbUrl: z.string().nullable(),
});
export const requestUploadInput = z.object({
    name: z.string().min(1).max(255),
    mime: z.string().min(1).max(160),
    size: z.number().int().positive().max(MAX_FILE_SIZE),
});
export const uploadTicketSchema = z.object({
    fileId: z.string(),
    /** Ide kell PUT-tal feltolteni a bajtokat. */
    uploadUrl: z.string(),
    /** A feltoltesnel ezt a fejlecet kell kuldeni, kulonben az alairas nem stimmel. */
    contentType: z.string(),
    expiresInSeconds: z.number(),
});
/** Ember szamara olvashato meret. */
export function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${Math.round(bytes / 1024)} kB`;
    const mb = bytes / (1024 * 1024);
    return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`;
}
//# sourceMappingURL=file.js.map